import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
export const Navigation = _ref => {
  let {
    page,
    claim = {
      id: 5
    },
    accountType
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Nav, {
    variant: "tabs",
    className: "mb-2"
  }, /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'general',
    to: `/${accountType}/claims/${claim.id}/financial_details/general`
  }, t('general'))), claim.claim_group.staffing_cost_type === 'rapid' && /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'employees_bio',
    to: `/${accountType}/claims/${claim.id}/financial_details/employees_bio`
  }, t('employee_bio'))), claim.claim_group.staffing_cost_type === 'rapid' && /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'employees_activity',
    to: `/${accountType}/claims/${claim.id}/financial_details/employees_activity`
  }, t('employee_activity'))), /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'staffing_costs',
    to: `/${accountType}/claims/${claim.id}/financial_details/staffing_costs`
  }, t('staffing_costs'))), /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'subcontractors',
    to: `/${accountType}/claims/${claim.id}/financial_details/subcontractors`
  }, t('subcontractors'))), /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'external_workers',
    to: `/${accountType}/claims/${claim.id}/financial_details/external_workers`
  }, t('external_workers'))), /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'consumables',
    to: `/${accountType}/claims/${claim.id}/financial_details/consumables`
  }, t('consumables'))), /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'software',
    to: `/${accountType}/claims/${claim.id}/financial_details/software`
  }, t('software'))), /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'cloud_computings',
    to: `/${accountType}/claims/${claim.id}/financial_details/cloud_computings`
  }, t('cloud_computings'))), /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'data_licences_costs',
    to: `/${accountType}/claims/${claim.id}/financial_details/data_licences_costs`
  }, t('data_licences_costs'))), claim.claim_group.rate_type !== 'sme' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'independent_rnd_contributions',
    to: `/${accountType}/claims/${claim.id}/financial_details/independent_rnd_contributions`
  }, t('independent_rnd_contributions'))), /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'payments_to_clinical_trials',
    to: `/${accountType}/claims/${claim.id}/financial_details/payments_to_clinical_trials`
  }, t('payments_to_clinical_trials'))))));
};